const PageSchema = () => import('./PageSchema'); // eslint-disable-line
const PageManageSchema = () => import('./pages/manage/PageManageSchema'); // eslint-disable-line
const PageSchemaDetails = () => import('./pages/PageSchemaDetails'); // eslint-disable-line
export default {
  path: 'schema',
  children: [
    {
      path: '',
      name: 'schema',
      component: PageSchema,
      meta: {
        title: 'Schemas de disponibilidade',
      },
    },
    {
      name: 'schema-manage',
      path: 'manage',
      component: PageManageSchema,
      params: {
        id: null,
      },
      meta: {
        title: 'Gerenciar schema',
      },
    },
    {
      name: 'schema-details',
      path: 'details/:id?',
      component: PageSchemaDetails,
      params: {
        id: null,
      },
      meta: {
        title: 'Detalhes do Esquema',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-capacity-management/features/schema/routes.js